import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { event } from "jquery";

@Component({
  selector: "app-voter-search-container",
  templateUrl: "./container.component.html",
  styleUrls: ["./container.component.scss"],
})
export class VoterSearchContainerComponent implements OnInit {
  data = {};
  lastNameSelect = {};
  searchData = [];
  addVisitorFlag: boolean = false;
  noDataFlag: boolean = false;
  selectedVisitor: any = {};
  showLeftSide: boolean = false;
  lastName: string = null;
  subIndex1 = 0;
  mainIndex = 0;
  search1Tab: number = 1;
  surnameTab: number = 3;
  voterListTab: number = 0;
  @Input() lastNameListDataChanged;
  message: any;
  @Output() receiveMessageValue = new EventEmitter();
  @Input() UpdatedLastname;


  constructor(private router: Router) { }

  ngOnInit() { }

  receiveMessages($event: any) {
    this.message = $event;
    this.receiveMessageValue.emit(this.message)
  }


  onSearchTriggered($event) {
    this.data = $event.data;
    this.lastName = $event.data;
    this.noDataFlag = false;
  }

  onSearchSurnameSelect($event) {
    this.lastNameSelect = $event.data;
    this.noDataFlag = false;
  }

  afterSearchData($event) {
    this.searchData = $event.data;
    if (this.searchData[1] == 0) {
      this.noDataFlag = true;
    }
  }

  onAddVisitorTriggered() {
    this.selectedVisitor = {};
    this.addVisitorFlag = true;
  }

  onSubMenuTriggered($event) {
    this.noDataFlag = false;
    this.subIndex1 = $event.subIndex;
    this.mainIndex = $event.mainIndex;
    console.log("this.mainIndex",this.mainIndex)
    console.log("this.subIndex1",this.subIndex1)
    if (
      this.mainIndex === 1 &&
      this.subIndex1 === 1
    ) {
      this.showLeftSide = true;
    } else {
      this.showLeftSide = false;
    }
console.log("showLeftSide",this.showLeftSide);

    if (this.mainIndex !== this.voterListTab) {
      this.data = $event = { type: "BYNAME" };
    } else {
      this.data = $event.data = { type: undefined };
    }
  }

  afterVoterAdd($event) {
    if ($event.type == "CANCEL") {
      this.addVisitorFlag = false;
    } else {
      this.addVisitorFlag = false;
      this.data = $event.data = { type: undefined };
    }
  }

  afterRowSelection($event) {
    this.selectedVisitor = $event.data;
    this.noDataFlag = false;

    this.showLeftSide = false;
    this.addVisitorFlag = true;
  }
}
